import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Tag,
    DatePicker,
    Select,
    InputNumber,
    Tabs
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useContext, useEffect, useRef } from "react";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { UploadOutlined, ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
const { TabPane } = Tabs;

const { Option } = Select;
const { RangePicker } = DatePicker;
const Search = Input.Search;

function Activity() {
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);


    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [selectedValue, setSelectedValue] = useState();
    const params = useParams()





    useEffect(() => {
        getData(params.id)
    }, [params.id])



    const getData = (id) => {
        request({
            url: `/admin/order/get-activity/${id}`,
            method: "GET",
            onSuccess: (data) => {
                console.log(data.data.data)
                setLoading(false);
                setList(data.data.data);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };


    return (
        <Main>
            <div class="timeline">
                <div class="timeline__header">
                    <span>Activity:</span>
                    <h1></h1>

                    <div class="process">
                        <div class="xd"></div>
                    </div>

                </div>

                {list.length > 0 && list.map((data) => (
                    <div class="line">
                        <div class="line-content">

                            <div class="content">
                                <h1>{data.status} ({moment(data.created_at).format("YYYY-MM-DD HH:mm")})</h1>
                                <p>{data.title}</p>
                            </div>


                        </div>
                    </div>
                ))}


            </div>


        </Main>
    );
}








export default Activity;
